import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { User } from '../models/user.model';
import { UserSessionService } from '../services/user/user.service';

@Directive({ selector: '[appHasRole]' })
export class HasRoleDirective implements OnInit {
  private currentUserRole!: string;
  //private currentInstitution:string;
  private permissions!: string[];

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private UserSessionService: UserSessionService,
  ) {}

  ngOnInit(): void {
    this.currentUserRole = this.UserSessionService.getRole();
    //this.currentInstitution = this.UserSessionService.getInstitution();
    //add validation -> this.currentUserDeal = this.UserSessionService.getDeal()
    this.updateView();
  }

  @Input() //val is the value that is passed through the component
  set appHasRole(val: string[]) {
    //appRole must be the selector name
    this.viewContainer.createEmbeddedView(this.templateRef); //renderiza el contenido, template ref hace referencia al componente en el que se implementa la directiva
    this.permissions = val.map((permission) => permission.toUpperCase());
    this.updateView();
  }

  updateView(): void {
    this.viewContainer.clear(); //limpia el contenedor

    if (this.checkPermission()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
  checkPermission(): boolean {
    let hasPermission = false;
    if (this.currentUserRole) {
      const permissionFound = this.permissions.includes(this.currentUserRole);
      if (permissionFound) {
        hasPermission = true;
      }
    }
    return hasPermission;
  }
}
